import './App.css';
import Home from './pages/home';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import Informes from './pages/informes';
import Productos from './pages/productos';
import Ajustes from './pages/ajustes';
import Usuarios from './pages/usuarios';
import Ventas from './pages/ventas';
import CierreCaja from './pages/cierre_caja';
import Egresos from './pages/egresos';
import NotFound from './pages/404';
import Gastos from './pages/gastos';
import Clientes from './pages/clientes';
import Proveedores from './pages/proveedores';
import Nomina from './pages/nomina';
import Login from './pages/login';
import CrearUsuarioApp from './pages/crear_usuario';
import { AuthProvider } from './aws/AuthContext';
import { ConfigProvider } from './context/ConfigContext';
import ProtectedRoute from './aws/ProtectedRoute';
import PoliticaPrivacidad from './pages/politica_privacidad';
import TerminosCondiciones from './pages/terminos_condiciones';
import Compras from './pages/compras';
import Inventario from './pages/inventario';
import RequirePermission from './aws/RequirePermission';
import RecuperarPassword from './pages/recuperar_password/RecuperarPassword';
import Facturacion from './pages/facturacion';
import Pedidos from './pages/pedidos';
import MiRuta from './pages/mi_ruta';

const queryClient = new QueryClient();

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <ConfigProvider>
          <Router>
            <Routes>
              {/* RUTAS PÚBLICAS */}
              <Route path="/" element={<Home />} />
              <Route path="/login" element={<Login />} />
              <Route path="/registro" element={<CrearUsuarioApp />} />
              <Route path="/politica-privacidad" element={<PoliticaPrivacidad />} />
              <Route path="/terminos-y-condiciones" element={<TerminosCondiciones />} />
              <Route path="/recuperar-clave" element={<RecuperarPassword />} />

              {/* RUTAS PROTEGIDAS (Grupo) */}
              <Route element={<ProtectedRoute />}>

                <Route path="/informes" element={
                  <RequirePermission permiso="informes:ver"><Informes /></RequirePermission>
                } />

                <Route path="/productos" element={
                  <RequirePermission permiso="productos:ver"><Productos /></RequirePermission>
                } />

                <Route path="/inventario" element={
                  <RequirePermission permiso="inventario:ver"><Inventario /></RequirePermission>
                } />

                <Route path="/ajustes" element={
                  <RequirePermission permiso="configuracion:ver"><Ajustes /></RequirePermission>
                } />

                <Route path="/usuarios" element={
                  <RequirePermission permiso="usuarios:ver"><Usuarios /></RequirePermission>
                } />

                <Route path="/ventas" element={
                  <RequirePermission permiso="ventas:ver"><Ventas /></RequirePermission>
                } />

                <Route path='/facturacion' element={
                  <RequirePermission permiso="facturacion:ver"><Facturacion /></RequirePermission>
                } />

                <Route path="/cierre-caja" element={
                  <RequirePermission permiso="caja:ver"><CierreCaja /></RequirePermission>
                } />

                <Route path="/gastos" element={
                  <RequirePermission permiso="gastos:ver"><Gastos /></RequirePermission>
                } />

                <Route path="/pedidos" element={
                  <RequirePermission permiso="pedidos:ver"><Pedidos /></RequirePermission>
                } />

                <Route path="/mi-ruta" element={
                  <RequirePermission permiso="ruta:ver"><MiRuta /></RequirePermission>
                } />

                <Route path="/compras" element={
                  <RequirePermission permiso="compras:ver"><Compras /></RequirePermission>
                } />

                <Route path="/clientes" element={
                  <RequirePermission permiso="clientes:ver"><Clientes /></RequirePermission>
                } />

                <Route path="/proveedores" element={
                  <RequirePermission permiso="proveedores:ver"><Proveedores /></RequirePermission>
                } />

                {/* Si nómina tiene un permiso, agrégalo. Si no, déjalo libre o crea el permiso */}
                <Route path="/nomina" element={<Nomina />} />
                <Route path="/egresos" element={<Egresos />} />
              </Route>

              <Route path="*" element={<NotFound />} />
            </Routes>
          </Router>
        </ConfigProvider>
      </AuthProvider>
    </QueryClientProvider>
  );
}

export default App;
